
define('ldsh!modules/form_editor/templates/preview_custom_separator', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-sm-12 ed-spacer ' +
((__t = ( hrAlign === 'center' ? '' : 'ed-spacer-' + hrAlign )) == null ? '' : __t) +
'" style="height: ' +
((__t = ( height )) == null ? '' : __t) +
'px" id="' +
((__t = ( elementId )) == null ? '' : __t) +
'">\n  ';
 if (showHr) { ;
__p += '\n  <hr class="hr-spacer" style="width: ' +
((__t = ( hrWidth )) == null ? '' : __t) +
'%; height: ' +
((__t = ( hrHeight )) == null ? '' : __t) +
'px;">\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

